import React, { useRef } from 'react';
var VeltAutocompleteChipTooltipName = function (props) {
    var userObject = props.userObject, userId = props.userId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-chip-tooltip-name", { ref: ref, "user-object": userObject ? (typeof userObject === 'object' ? JSON.stringify(userObject) : userObject) : undefined, "user-id": userId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltAutocompleteChipTooltipName;
